import { deleteLeasedEquipmentModel } from "actions/Utilities/LeasedEquipmentModel";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";

export default function useDeleteModel() {
  const { mutate } = useMutation(
    (ids: number[]) => deleteLeasedEquipmentModel(ids),
    {
      onSuccess: (res: any) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Model Disabled Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Model Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Model failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Model not found":
            toast.fire("Disabling Model failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Disabling Model failed", res.Message, "error");
        }
      },
      onError: (error) => {
        toast.fire("Disabling Model failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
}
